const React = require('react');
import classNames from 'classnames';
import Styles from './table-column.less';

const baseClass = Styles.td;

module.exports = React.createClass({
  displayName: 'TableColumn',
  propTypes: {
    className: React.PropTypes.string,
    onClick: React.PropTypes.func,
    onHover: React.PropTypes.func,
    selectable: React.PropTypes.bool,
    selected: React.PropTypes.bool,
  },
  getClass() {
    return classNames(baseClass, this.props.className, this.props.type === 'preview' ? Styles.icon : "");
  },
  getChildren() {
    return this.props.children;
  },
  onClick(e) {
    if (this.props.onClick) this.props.onClick();
    e.stopPropagation();
  },
  render: require('./table-column.rt')
});


/** WEBPACK FOOTER **
 ** ./src/table/table-column/table-column.js
 **/